module.exports = __webpack_public_path__ + "img/refund-fill.7a5198ee.svg";